import { defineField, defineType } from 'sanity'
import { richTextSimple } from '../../data/richText'

export default defineType({
  name: 'configuratorWarning',
  title: 'Configurator Warning',
  type: 'document',
  orderings: [
    {
      title: 'Title A-Z',
      name: 'titleAsc',
      by: [{field: 'title', direction: 'asc'}],
    },
  ],
  fields: [
    defineField({
      name: 'title',
      title: 'Title',
      type: 'string',
    }),
    defineField({
      name: 'shortDescription',
      title: 'Short Description',
      type: 'string',
    }),
    defineField({
      name: 'description',
      title: 'Description',
      type: 'array',
      of: richTextSimple,
    }),
  ],
  preview: {
    select: {
      name: 'title',
    },
    prepare({ name: title = 'New Warning' }) {
      return { title, subtitle: 'Configurator Warning' }
    },
  },
})